// extracted by mini-css-extract-plugin
export var currencyInput = "_kh-1";
export var currencySymbol = "_kh-0";